import { apiSlice } from "@/services/api-slice";
import * as inter from "./works-orders.interface";
import { APIResponse } from "@/types/custom-http";


export const worksOrdersApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
      // Obtener Listado Simple de Ordenes de Trabajo con filtrado
      getWorksOrders: builder.query<APIResponse<inter.WorkOrderSimple[]>, inter.ParamsWorkOrder>({
        query: (params) => { 
          const finalParams: inter.ParamsWorkOrder = {
            type_id: params.type_id,
            status_id: params.status_id,
          };
            return { 
              url: "auth/works-orders",
              params: finalParams,
            }; 
          },
        providesTags: ["WorkOrders"],
      }),

      // Obtener Listado Simple de Ordenes de Trabajo Pendientes (code <= 40)
      getWorksOrdersPending: builder.query<APIResponse<inter.WorkOrderSimplePaginatedData>, { search?: string | null; page?: number; size?: number } | void>({
        query: (params) => {
          const finalParams: { search?: string; page?: number; size?: number } = {};
          const search = params && "search" in params ? params.search : null;
          const page = params && "page" in params ? params.page : undefined;
          const size = params && "size" in params ? params.size : undefined;
          if (search && search.trim().length > 0) {
            finalParams.search = search.trim();
          }
          if (typeof page === "number" && page > 0) {
            finalParams.page = page;
          }
          if (typeof size === "number" && size > 0) {
            finalParams.size = size;
          }
          return {
            url: "auth/works-orders/pending",
            params: Object.keys(finalParams).length > 0 ? finalParams : undefined,
          };
        },
        providesTags: ["WorkOrders"],
      }),

      // Obtener Listado Simple de Ordenes de Trabajo Activas (code <= 45)
      getWorksOrdersActive: builder.query<APIResponse<inter.WorkOrderSimplePaginatedData>, { search?: string | null; page?: number; size?: number } | void>({
        query: (params) => {
          const finalParams: { search?: string; page?: number; size?: number } = {};
          const search = params && "search" in params ? params.search : null;
          const page = params && "page" in params ? params.page : undefined;
          const size = params && "size" in params ? params.size : undefined;
          if (search && search.trim().length > 0) {
            finalParams.search = search.trim();
          }
          if (typeof page === "number" && page > 0) {
            finalParams.page = page;
          }
          if (typeof size === "number" && size > 0) {
            finalParams.size = size;
          }
        return {
            url: "auth/works-orders/active",
            params: Object.keys(finalParams).length > 0 ? finalParams : undefined,
          };
        },
        providesTags: ["WorkOrders"],
      }),

      // Obtener Listado Completo de Ordenes de Trabajo
      getWorksOrdersFull: builder.query<APIResponse<inter.WorkOrderFull[]>, void>({
        query: () => { return { url: "auth/works-orders/full" }; },
        providesTags: ["WorkOrders"],
      }),

      // Obtener Listado de Ordenes de Trabajo Salientes
      getWorksOrdersOutgoing: builder.query<APIResponse<{ page: number; size: number; total: number; totalPages: number ; data: inter.WorkOrderFull[]}>, inter.WorkOrderListOutgoingRequest>({
        query: (params) => { 
          const finalParams: inter.WorkOrderListOutgoingRequest = {
            page: params.page,
            size: params.size,
          };
          if (params.search) {
            finalParams.search = params.search;
          }
          return { 
            url: "auth/works-orders/outgoing",
            params: finalParams, 
          }; 
        },
        providesTags: ["WorkOrders"],
      }),

      // Consumir Stock para una Orden de Trabajo
      consumeStockWorkOrder: builder.mutation<APIResponse<inter.WorkOrderFull>, inter.WorkOrderAssignament>({
        query: (data) => ({
          url: 'auth/works-orders/consume',
          method: 'POST',
          body: data,
        }),
        invalidatesTags: ['WorkOrders'],
      }),

      // Devolver Stock de una Orden de Trabajo
      returnStockWorkOrder: builder.mutation<APIResponse<inter.WorkOrderFull>, inter.WorkOrderReturnRequest>({
        query: (data) => ({
          url: 'auth/works-orders/returns',
          method: 'POST',
          body: data,
        }),
        invalidatesTags: ['WorkOrders'],
      }),

      // Obtener Configuraciones de Ordenes de Trabajo
      getSettingsWorksOrders: builder.query<APIResponse<inter.SettingsWorksOrders>, void>({
        query: () => { return { url: "auth/works-orders/settings" }; },
        providesTags: ["WorkOrders"],
      }),

      // Obtener Datos de una Orden de Trabajo por ID
      getWorkOrderById: builder.query<APIResponse<inter.WorkOrderFull>, number>({
        query: (id) => { return { url: `auth/works-orders/${id}` }; },
        providesTags: ["WorkOrders"],
      }),

      // Obtener Resumen de Ordenes de Trabajo
      getWorkOrderStatisticsSummary: builder.query<APIResponse<inter.WorkOrderStatisticsResponse>, void>({
        query: () => { return { url: "auth/works-orders/summary" }; },
        providesTags: ["WorkOrders"],
      }),
      
      // Crear una nueva Orden de Trabajo
      createWorkOrder: builder.mutation<APIResponse<inter.WorkOrderSimple>, inter.CreateWorkOrder>({
        query: (wo) => ({
          url: 'auth/works-orders',
          method: 'POST',
          body: wo,
        }),
        invalidatesTags: ['WorkOrders'],
      }),

      // Actualizar una Orden de Trabajo
      updateWorkOrder: builder.mutation<APIResponse<inter.WorkOrderSimple>, {id: number, changes: inter.UpdateWorkOrder}>({
        query: ({id, changes}) => ({
          url: `auth/works-orders/${id}`,
          method: 'PUT',
          body: changes,
        }),
        invalidatesTags: ['WorkOrders'],
      }),
    
      // Buscar Ordenes de Trabajo
      searchWorksOrders: builder.query<APIResponse<inter.WorkOrderSimple[]>, inter.WorkOrdersSearchRequest>({
        query: (params) => { 
          const finalParams: inter.WorkOrdersSearchRequest = {};
          if (params.search) {
            finalParams.search = params.search;
          }

          if (params.state) {
            finalParams.state = params.state;
          }
          return {
          url: `auth/works-orders/search`,
          params: finalParams,
        }},
        providesTags: ["WorkOrders"],
      })

    }),
  });
  
  export const {
    useGetWorksOrdersQuery,
    useLazyGetWorksOrdersQuery,
    useGetWorksOrdersPendingQuery,
    useLazyGetWorksOrdersPendingQuery,
    useGetWorksOrdersActiveQuery,
    useLazyGetWorksOrdersActiveQuery,
    useGetWorksOrdersFullQuery,
    useConsumeStockWorkOrderMutation,
    useReturnStockWorkOrderMutation,
    useGetWorksOrdersOutgoingQuery,
    useLazyGetWorksOrdersOutgoingQuery,
    useLazyGetWorksOrdersFullQuery,
    useGetWorkOrderByIdQuery,
    useLazyGetWorkOrderByIdQuery,
    useGetSettingsWorksOrdersQuery,
    useGetWorkOrderStatisticsSummaryQuery,
    useCreateWorkOrderMutation,
    useUpdateWorkOrderMutation,
    useSearchWorksOrdersQuery,
    useLazySearchWorksOrdersQuery
  } = worksOrdersApi;
